import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';


const ModalUploadTenantsForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
    const [companyID] = useState(1); // Replace with actual companyID
    const [location] = useState('');
    const [houses, setHouses] = useState([]);
  const [uploadMethod, setUploadMethod] = useState('');
  const [businessLocations, setBusinessLocations] = useState([]);
  const [tenantsData, setTenantsData] = useState({
    tenantLastName: '',
    tenantFirstName: '',
    tenantGender: '',
    tenantPhone: '',
    tenantEmail: '',
    tenantNationality: '',
    tenantNRC: '',
    houseNumber: '',
    business_locationIDTenants: ''
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [fileData, setFileData] = useState(null);

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationHousesOnUploadForm');
    formData.append("companyID", companyID);
    formData.append("location", location);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocations(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
    }, []);

    useEffect(() => {
      // Create formData object
      const formData = new FormData();
      formData.append("apiType", 'getHousesOnUploadForm');
      formData.append("businessLocationID", location);
      // Fetch plot options from the backend using POST method
      axios.post(`${server_app_api_php}/server/index.php`, formData)
        .then(response => {
          setHouses(response.data);
        })
        .catch(error => {
          //alert('There was an error fetching the plots!', error);
        });
    }, []);

  useEffect(() => {
    const { tenantLastName, tenantFirstName, tenantPhone, tenantEmail, tenantGender, business_locationIDTenants } = tenantsData;
    setIsButtonDisabled(!(tenantLastName && tenantFirstName && tenantPhone && tenantEmail && tenantGender && business_locationIDTenants));
  }, [tenantsData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTenantsData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFileData(e.target.files[0]);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    for (const key in tenantsData) {
      formData.append(key, tenantsData[key]);
    }
    formData.append('companyID', companyID);
    formData.append('businessLocationID', location);
    formData.append('apiType', 'registerTenants');
    
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        //console.log('what i receive = ', response.data);
        const { data } = response;
        if (data === 'Successful') {
          alert('Successfully Uploaded');
          setTenantsData({
            tenantLastName: '',
            tenantFirstName: '',
            tenantGender: '',
            tenantPhone: '',
            tenantEmail: '',
            tenantNationality: '',
            tenantNRC: '',
            houseNumber: '',
            business_locationIDTenants: ''
          });
        } else if (data === 'Failed') {
          alert('Failed to Upload. Contact Support Team');
        } else if (data === 'Duplicate') {
          alert('Failed to Upload. Duplicate Entry');
        }
      })
      .catch(error => {
        alert('There Seems To be a Problem with Your Internet Connectivity. If this Problem continues, kindly contact Support Team');
        console.error('There was an error!', error);
      });
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('excelTenants', fileData);
    formData.append('companyID', companyID);
    formData.append('businessLocationID', location);
    formData.append('apiType', 'registerTenantsExcel');

    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        const { data } = response;
        if (data === 'Upload Completed Successfully' || data === '') {
          alert('Data Upload Completed Successfully');
        } else {
          alert(data);
        }
      })
      .catch(error => {
        alert('Error : Please Check Your Internet Connection. If This Persists, Kindly Contact Support Team');
       // console.error('There was an error!', error);
      });
  };

  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalUploadTenantsForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Register Tenants</p>
         
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                <select
                  className="custom-select d-block w-100"
                  id="uploadMethodTenants"
                  name="uploadMethodTenants"
                  value={uploadMethod}
                  onChange={(e) => setUploadMethod(e.target.value)}
                >
                  <option value="">Choose Upload Method..</option>
                  <option>Single Form</option>
                  <option>Upload Excel File</option>
                </select>
              </div>
            </div>
            {uploadMethod === 'Upload Excel File' && (
              <div className="row" id="uploadExcelFileTenants">
                <form id="fileUploadFormTenants" onSubmit={handleFileUpload}>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <select
                      className="custom-select d-block w-100"
                      id="business_locationIDTenantsExcel"
                      name="business_locationIDTenantsExcel"
                      required
                      value={tenantsData.business_locationIDTenantsExcel}
                      onChange={handleInputChange}
                    >
                      <option value="">Choose Business Location..</option>
                      {businessLocations.map(location => (
                        <option key={location.businessLocationID} value={location.businessLocationID}>
                          {location.businessLocationName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                    <label htmlFor="excelTenants">Select Excel File</label><br />
                    <div className="md-form md-outline">
                      <input type="file" id="excelTenants" name="excelTenants" className="form-control form-control-sm" onChange={handleFileChange} />
                      <input type="hidden" id="companyID" name="companyID" value={window.userCompanyID} />
                      <input type="hidden" id="businessLocationID" name="businessLocationID" value={window.userBusinessLocationID} />
                      <input type="hidden" id="apiType" name="apiType" value="registerTenantsExcel" />
                    </div>
                  </div>
                  <div className="text-center mt-0">
                    <button className="btn btn-success" id="registerTenantsExcel">Upload <i className="fas fa-pen-alt ml-1"></i></button>
                  </div>
                </form>
              </div>
            )}
            {uploadMethod === 'Single Form' && (
              <div className="row" id="singleFormTenants">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select
                    className="custom-select d-block w-100"
                    id="business_locationIDTenants"
                    name="business_locationIDTenants"
                    value={tenantsData.business_locationIDTenants}
                    onChange={handleInputChange}
                  >
                    <option value="">Choose Business Location..</option>
                    {businessLocations.map(location => (
                      <option key={location.businessLocationID} value={location.businessLocationID}>
                        {location.businessLocationName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="tenantLastName" name="tenantLastName" className="form-control form-control-md" value={tenantsData.tenantLastName} onChange={handleInputChange} />
                    <label htmlFor="tenantLastName">Last Name</label>
                  </div>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="tenantFirstName" name="tenantFirstName" className="form-control form-control-md" value={tenantsData.tenantFirstName} onChange={handleInputChange} />
                    <label htmlFor="tenantFirstName">First Name</label>
                  </div>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="tenantPhone" name="tenantPhone" className="form-control form-control-md" value={tenantsData.tenantPhone} onChange={handleInputChange} />
                    <label htmlFor="tenantPhone">Phone</label>
                  </div>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="email" id="tenantEmail" name="tenantEmail" className="form-control form-control-md" value={tenantsData.tenantEmail} onChange={handleInputChange} />
                    <label htmlFor="tenantEmail">Email</label>
                  </div>
                </div>
                <div className="col-lg-4 col-xl-4 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <select className="custom-select d-block w-100" id="tenantGender" name="tenantGender" value={tenantsData.tenantGender} onChange={handleInputChange}>
                      <option value="">Choose Gender...</option>
                      <option>Male</option>
                      <option>Female</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-4 col-xl-4 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="tenantNationality" name="tenantNationality" className="form-control form-control-md" value={tenantsData.tenantNationality} onChange={handleInputChange} />
                    <label htmlFor="tenantNationality">Nationality</label>
                  </div>
                </div>
                <div className="col-lg-4 col-xl-4 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="tenantNRC" name="tenantNRC" className="form-control form-control-md" value={tenantsData.tenantNRC} onChange={handleInputChange} />
                    <label htmlFor="tenantNRC">NRC</label>
                  </div>
                </div>
                 <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="houseNumber" name="houseNumber" required value={tenantsData.houseNumber} onChange={handleInputChange}>
                    <option value="">Choose House..</option>
                    {houses.map(house => (
<option key={house.rentalsID} value={house.rentalsID}>Block = {house.block}, House Number = {house.houseNumber}, Rental =ZMW {house.rentalPrice}</option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer justify-content-center">
            {uploadMethod === 'Single Form' && (
              <button type="submit" className="btn btn-success" onClick={handleFormSubmit} disabled={isButtonDisabled}>Submit</button>
            )}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalUploadTenantsForm;
